// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OfficeAttendance  {
    _originalTypeClassName = "Loom.BO.OfficeAttendance";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OfficeAttendance.translate = translateService;
}
this.Id = null;
this.Day = null;
this.IsAttending = false;
this.DayStr = null;
this.WeekInterval = null;
this.FacilityName = null;
this.IsOnLeave = false;
this.IsWorkableDay = false;
this.IsOnTrip = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Day:any;
IsAttending:any;
DayStr:any;
WeekInterval:any;
FacilityName:any;
IsOnLeave:any;
IsWorkableDay:any;
IsOnTrip:any;
OfficeAttendanceScheduleForEven:any;
Person:any;
OfficeAttendanceScheduleForOdd:any;
static setOfficeAttendanceScheduleForEven = ($this, value) => {
var oldValue = $this.OfficeAttendanceScheduleForEven;
$this.OfficeAttendanceScheduleForEven = value;
if (value != null) {
if (oldValue != null) {
Domain.OfficeAttendanceSchedule.removeOfficeAttendanceEvenWeeks(oldValue, $this);
}
Domain.OfficeAttendanceSchedule.addOfficeAttendanceEvenWeeks(value, $this);
}
}
static setPerson = ($this, value) => {
var oldValue = $this.Person;
$this.Person = value;
if (value != null) {
}
}
static setOfficeAttendanceScheduleForOdd = ($this, value) => {
var oldValue = $this.OfficeAttendanceScheduleForOdd;
$this.OfficeAttendanceScheduleForOdd = value;
if (value != null) {
if (oldValue != null) {
Domain.OfficeAttendanceSchedule.removeOfficeAttendanceOddWeeks(oldValue, $this);
}
Domain.OfficeAttendanceSchedule.addOfficeAttendanceOddWeeks(value, $this);
}
}

static GetFacilityName($this: any): any{if (($this?.OfficeAttendanceScheduleForEven != null)) {return $this?.OfficeAttendanceScheduleForEven?.Facility?.Name;}
if (($this?.OfficeAttendanceScheduleForOdd != null)) {return $this?.OfficeAttendanceScheduleForOdd?.Facility?.Name;}
return "N/A";
}
static GetPersonName($this: any): any{return $this?.Day?.toString() + " " + $this?.Person?.FullName;
}
static Validate($this: any): any{if ($this?.Person == null || Domain.Person.IsNew($this?.Person)) {throw Error("No person selected");}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}